// Apolo IDE — SidePanel: Terminal tab (Epic 17 placeholder).

export default function TerminalTab() {
  return (
    <div className="flex h-full items-center justify-center px-4 py-6 text-center">
      <p className="max-w-xs text-sm text-apolo-textTertiary">
        Terminal interativo é desbloqueado pelo Epic 17 (Desktop Triplo). Por enquanto, os comandos
        executados pelo agente aparecem como mensagens tipo Tool no chat.
      </p>
    </div>
  );
}
